import { ViewModel,View, ViewModelMessage, ObservableArray } from "binder"
import moment from "moment";
import { itemContainer } from "src/common/reusableComponents/searchableSelectorBase/searchableSelectorBase-viewModel";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerConnection } from "src/server/serverConnection";
import { getAsNumber } from "src/uicomponents/components/utilities";
import { CarModel, measuredProductDto, productForSelector, ProductSearchableSelectorViewModel } from "src/Warehouse/productSearch/productSearchableSelector/productSearchableSelector-viewModel";
import  { HuntMediatorManipulationView } from "./huntMediatorManipulation-view"
import { stringIsNullOrEmpty } from "src/common/utilities";

export class HuntMediatorManipulationViewModel extends ViewModel implements IPopup{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.stateStack = [];   
    }
    GetDefaultView(): View <ViewModel> {
        return new HuntMediatorManipulationView();
    }
    public getTypeId(): string {
        return "VM-F5CA4E9D-CC76-4F0C-A17A-BAD58D4EBE7C"
    }

    private stateStack:HuntViewModel[];
    public set currentProduct(v: HuntViewModel) { this._currentProduct = v; } public get currentProduct(): HuntViewModel { return this._currentProduct;} private _currentProduct: HuntViewModel;
    public set customerId(v: string) { this._customerId = v; } public get customerId(): string { return this._customerId;} private _customerId: string;
    
    async loadById (measuredProductId:string, customerId:string, otherResult:ObservableArray<itemContainer<productForSelector>>, carBrandId: string, carModelId: string) {
        let currentHunt : HuntViewModel = new HuntViewModel(this);
        currentHunt.loadById(measuredProductId, customerId, otherResult, carBrandId, carModelId);
        this.customerId = customerId;
        this.currentProduct = currentHunt;
        this.stateStack.push(this.currentProduct);
    }

    back () {
        if (this.stateStack.length > 1 ) {
            this.stateStack.pop();
            this.currentProduct = this.stateStack.at(-1);
        }
    }

    override handleMessage(message:ViewModelMessage){
        if(message instanceof RequestHuntProductMessage){
            let oldOtherResults = ObservableArray.create<itemContainer<productForSelector>>();
            oldOtherResults.update(...this.currentProduct.otherSearchResults.map(x => {
                let r = new itemContainer<productForSelector>(this.currentProduct.productSelector);
                let y = new productForSelector(this);
                y.productName = x.name;
                y.code = x.code;
                let q = new measuredProductDto(this);
                q.id = x.id;
                y.measuredProducts.push(q);
                r.content = y;
                return r;
            }));
            this.loadById(message.measuredProductId, this.customerId, oldOtherResults, this.currentProduct.productSelector.carBrandId, this.currentProduct.productSelector.carModelId);
            return null;
        }else{
            return super.handleMessage(message);
        }
    }

    async confirm () {
        let verificationResult =  this.currentProduct.verify();
            if(verificationResult.length>0){
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage,'عدم امکان انتخاب کالا');
                return;
            }
        let result = this.currentProduct.GetProductInfo();
        this.closePopup(result);
    }

    close() {
        this.closePopup({
            carModelId : this.currentProduct.productSelector.carModelId,
            carBrandId : this.currentProduct.productSelector.carBrandId,
            isAdvancedSearch : this.currentProduct.productSelector.isAdvancedSearch,
        });
    }

    closePopup(result:any = null) {

    }
}
export class HuntedProduct{
    public measuredProductId:string;
    public productCode:string;
    public productName:string;
    public productCarModel:string;
    public carBrandId:string;
    public carModelId:string;
    public isAdvancedSearch:boolean;
    public balance:number;
    public price:number;
    public warehouseId:string;
    public warehouesName:string;
    public districtId:string;
    public districtName:string;
}
export class HuntViewModel extends ViewModel{
    
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        this.replaceableProducts = ObservableArray.create();
        this.otherSearchResults = ObservableArray.create();
        this.warehousePrices = ObservableArray.create();
        this.systemPriceHistories = ObservableArray.create();
        this.invoicePrices = ObservableArray.create();
        this.productSelector = new ProductSearchableSelectorViewModel(this,false, true, true);
        this.files = ObservableArray.create<file>();
        this.inWayPerWarehouse = ObservableArray.create<InWayAmountPerWarehouse>();
        this.carModels = ObservableArray.create<CarModel>();

        this.productSelector.onSelectionChanged = q=>{
            let message = new RequestHuntProductMessage(q.measuredProducts[0].id);
            this.otherSearchResults.update(...this.productSelector.items.map(x=>{
                let y = new OtherSearchResultProduct(this);
                y.id = x.content.measuredProducts[0].id;
                y.name = x.content.productName;
                y.code = x.content.code;
                return y;
            }));
            this.handleMessage(message);      
        } 
    }
    
    public set measuredProductId(v: string) { this._measuredProductId = v; } public get measuredProductId(): string { return this._measuredProductId;} private _measuredProductId: string;
    public set productId(v: string) { this._productId = v; } public get productId(): string { return this._productId;} private _productId: string;
    public set productName(v: string) { this._productName = v; } public get productName(): string { return this._productName;} private _productName: string;
    public set productCode(v: string) { this._productCode = v; } public get productCode(): string { return this._productCode;} private _productCode: string;
    public set productCarModel(v: string) { this._productCarModel = v; } public get productCarModel(): string { return this._productCarModel;} private _productCarModel: string;
    public set colorName(v: string) { this._colorName = v; } public get colorName(): string { return this._colorName;} private _colorName: string;
    public set colorId(v: string) { this._colorId = v; } public get colorId(): string { return this._colorId;} private _colorId: string;
    public set countryId(v: string) { this._countryId = v; } public get countryId(): string { return this._countryId;} private _countryId: string;
    public set countryName(v: string) { this._countryName = v; } public get countryName(): string { return this._countryName;} private _countryName: string;
    public set pncId(v: string) { this._pncId = v; } public get pncId(): string { return this._pncId;} private _pncId: string;
    public set pncName(v: string) { this._pncName = v; } public get pncName(): string { return this._pncName;} private _pncName: string;
    public set brandId(v: string) { this._brandId = v; } public get brandId(): string { return this._brandId;} private _brandId: string;
    public set brandName(v: string) { this._brandName = v; } public get brandName(): string { return this._brandName;} private _brandName: string;
    public set partNumberId(v: string) { this._partNumberId = v; } public get partNumberId(): string { return this._partNumberId;} private _partNumberId: string;
    public set partNumberName(v: string) { this._partNumberName = v; } public get partNumberName(): string { return this._partNumberName;} private _partNumberName: string;
    public set currentFee(v: number) { this._currentFee =getAsNumber(v,true); } public get currentFee(): number { return this._currentFee;} private _currentFee: number;
    public set systemPrice(v: number) { this._systemPrice = v; } public get systemPrice(): number { return this._systemPrice;} private _systemPrice: number;
    public set hasInWay(v: boolean) { this._hasInWay = v; } public get hasInWay(): boolean { return this._hasInWay;} private _hasInWay: boolean;
    public set inWayAmount(v: number) { this._inWayAmount = v; } public get inWayAmount(): number { return this._inWayAmount;} private _inWayAmount: number;
    public set inWayDate(v: moment.Moment) { this._inWayDate = v; } public get inWayDate(): moment.Moment { return this._inWayDate;} private _inWayDate: moment.Moment;
    
    public set inWayPerWarehouse(v: ObservableArray<InWayAmountPerWarehouse>) { this._inWayPerWarehouse = v; } public get inWayPerWarehouse(): ObservableArray<InWayAmountPerWarehouse> { return this._inWayPerWarehouse;} private _inWayPerWarehouse: ObservableArray<InWayAmountPerWarehouse>;
    public set hasNotReplaceableProducts(v: boolean) { this._hasNotReplaceableProducts = v; } public get hasNotReplaceableProducts(): boolean { return this._hasNotReplaceableProducts;} private _hasNotReplaceableProducts: boolean;
    public set replaceableProducts(v: ObservableArray<ReplaceableProduct>) { this._replaceableProducts = v; } public get replaceableProducts(): ObservableArray<ReplaceableProduct> { return this._replaceableProducts;} private _replaceableProducts: ObservableArray<ReplaceableProduct>;
    public set otherSearchResults(v: ObservableArray<OtherSearchResultProduct>) { this._otherSearchResults = v; } public get otherSearchResults(): ObservableArray<OtherSearchResultProduct> { return this._otherSearchResults;} private _otherSearchResults: ObservableArray<OtherSearchResultProduct>;
    public set warehousePrices(v: ObservableArray<WarehousePrice>) { this._warehousePrices = v; } public get warehousePrices(): ObservableArray<WarehousePrice> { return this._warehousePrices;} private _warehousePrices: ObservableArray<WarehousePrice>;
    public set systemPriceHistories(v: ObservableArray<SystemPriceHistory>) { this._systemPriceHistories = v; } public get systemPriceHistories(): ObservableArray<SystemPriceHistory> { return this._systemPriceHistories;} private _systemPriceHistories: ObservableArray<SystemPriceHistory>;
    public set invoicePrices(v: ObservableArray<InvoicePrices>) { this._invoicePrices = v; } public get invoicePrices(): ObservableArray<InvoicePrices> { return this._invoicePrices;} private _invoicePrices: ObservableArray<InvoicePrices>;
    public set productSelector(v: ProductSearchableSelectorViewModel) { this._productSelector = v; } public get productSelector(): ProductSearchableSelectorViewModel { return this._productSelector;} private _productSelector: ProductSearchableSelectorViewModel;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set files(v: ObservableArray<file>) { this._files = v; } public get files(): ObservableArray<file> { return this._files;} private _files: ObservableArray<file>;
    public set problem(v: string) { this._problem = v; } public get problem(): string { return this._problem;} private _problem: string;
    public set isLoadingCarModel(v: boolean) { this._isLoadingCarModel = v; } public get isLoadingCarModel(): boolean { return this._isLoadingCarModel;} private _isLoadingCarModel: boolean;
    public set carModels(v: ObservableArray<CarModel>) { this._carModels = v; } public get carModels(): ObservableArray<CarModel> { return this._carModels;} private _carModels: ObservableArray<CarModel>;
    public set hasCarModel(v: boolean) { this._hasCarModel = v; } public get hasCarModel(): boolean { return this._hasCarModel;} private _hasCarModel: boolean;
    
    public set carModelId(v: string) { this._carModelId = v; } public get carModelId(): string { return this._carModelId;} private _carModelId: string;
    public set carBrandId(v: string) { this._carBrandId = v; } public get carBrandId(): string { return this._carBrandId;} private _carBrandId: string;
    
    private _isCarModelLoaded : boolean;

    async loadById(id:string, customerId, otherSearchResults:ObservableArray<itemContainer<productForSelector>>, carBrandId: string, carModelId: string) {
        try {
            this.isLoading = true;
            var sessionId = this.handleMessage(new RequestInvoiceCreationSessionIdMessage());
            let result = await ServerConnection.callServer('Complex/SellServices/HuntProduct',{
                Id:id,
                CustomerId: customerId,
                SessionId : sessionId
            });
            this.productSelector.carBrandId = carBrandId;
            this.productSelector.carModelId = carModelId;
            this.productSelector.isAdvancedSearch = stringIsNullOrEmpty(carModelId) == false;

            this.measuredProductId = result.MeasuredProductId;
            this.productId = result.ProductId;
            this.productName = result.ProductName;
            this.productCode = result.ProductCode;
            this.productCarModel = result.ProductCarModel;
            this.hasCarModel = result.HasCarModel;
            this.currentFee = result.CurrentFee;
            this.systemPrice = result.CurrentFee;
            this.inWayAmount = result.InWayAmount;
            this.inWayDate = result.InWayDate==null? null : moment.utc(result.InWayDate);
            this.hasInWay = this.inWayAmount != 0;
            this.colorId = result.ColorId;
            this.colorName = result.ColorName;
            this.countryId = result.CountryId;
            this.countryName = result.CountryName;
            this.brandId = result.BrandId;
            this.brandName = result.BrandName;
            this.pncId = result.PncId;
            this.pncName = result.PncName;
            this.partNumberId = result.PartNumberId;
            this.partNumberName = result.ProductName;
            this.problem = result.Problem;
            this.inWayPerWarehouse.update(...result.InWayAmountsPerWarehouse.map(x=>{
                let y = new InWayAmountPerWarehouse(this);
                y.warehouseName = x.WarehouseName;
                y.warehouseId = x.WarehouseId;
                y.inWayAmount = x.Amount;
                return y;
            }));
            this.replaceableProducts.update(...result.ReplaceableProducts.map(x=>{
                let y = new ReplaceableProduct(this);
                y.id = x.PartNumberId;
                y.name = x.PartNumberName;
                y.code = x.PartNumberCode;
                return y;
            }));
            this.hasNotReplaceableProducts = this.replaceableProducts.length == 0;
            this.otherSearchResults.update(...otherSearchResults.map(x=>{
                let y = new OtherSearchResultProduct(this);
                y.id = x.content.measuredProducts[0].id;
                y.name = x.content.productName;
                y.code = x.content.code;
                y.hasFocus = y.id == this.measuredProductId;
                return y;
            }));
            this.warehousePrices.update(...result.Warehouses.map(x=>{
                let y = new WarehousePrice(this);
                y.warehouseId = x.WarehouseId;
                y.name = x.Name;
                y.districtId = x.DistrictId;
                y.districtName = x.DistrictName;
                y.balance = x.AccessibleBalance;
                y.canSelect = x.CanSelect;
                y.canDelivery = x.CanDelivery;
                y.price = x.Price;
                y.reserveAmount = x.ReserveAmount;
                return y;
            }));
            this.systemPriceHistories.update(...result.SystemFeeHistory.map((x,i)=>{
                let y = new SystemPriceHistory(this);
                y.rowNumber = i+1;
                y.systemPrice = x.Price;
                y.from = moment.utc(x.From);
                y.until = x.Until==null? null : moment.utc(x.Until);
                return y;
            }));
            this.invoicePrices.update(...result.InvoicePrices.map((x,i)=>{
                let q = new InvoicePrices(this);
                q.rowNumber = i+1;
                q.price = x.Price;
                q.invoiceNumber = x.InvoiceNumber;
                q.warehouseName = x.WarehouseName;
                q.districtName = x.DistrictName;
                q.customerName = x.CustomerName;
                q.createdDate = moment.utc(x.CreatedDate);
                return q;
            }));
            this.files.update(...result.ProductImages.map((q,i)=>{
                let r = new file(this);
                r.name = (i+1).toString();
                r.path = q.Path;
                return r;
            }));
            this.scrollToSelected();
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }

    }

    private scrollToSelected(){
        const container = document.getElementsByClassName("otherSearchResults")[0] as HTMLElement;
        const target = document.getElementsByClassName("scrolltarget")[0] as HTMLElement;
        if (container && target) {
            target.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
        }
    }

    public async ShowAllCarModels(){
        if(this._isCarModelLoaded==true){
            return;
        }
        try {
            this.isLoadingCarModel = true;
            let result =await ServerConnection.callServer('/Complex/WarehouseServices/GetAllCarModelsOfProduct',{
                ProductId : this.productId
            });
            this.carModels.update(...result.CarModels.map(q=>{
                let r = new CarModel(this);
                r.fromYear = q.FromYear;
                r.toYear = q.UntilYear;
                r.carModelName = q.Name;
                r.carModelCode = q.Code;
                return r;
            }))
            this._isCarModelLoaded = true;
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoadingCarModel = false;
        }
    }

    selectWarehouse(warehouse: WarehousePrice) {
        this.warehousePrices.forEach(x=>x.selected=false);
        warehouse.selected = true;
        this.currentFee = warehouse.price;
    }
    
    GetProductInfo():HuntedProduct {
        let result = new HuntedProduct();
        let selectedWarehouse = this.warehousePrices.filter(q=>q.selected==true)[0];
        result.measuredProductId = this.measuredProductId;
        result.productCode = this.productCode;
        result.productName = this.productName;
        result.productCarModel = this.productCarModel;
        result.balance = selectedWarehouse.balance;
        result.districtId = selectedWarehouse.districtId;
        result.districtName = selectedWarehouse.districtName;
        result.price = this.currentFee;
        result.warehouesName = selectedWarehouse.name;
        result.warehouseId = selectedWarehouse.warehouseId;
        result.carModelId = this.productSelector.carModelId;
        result.carBrandId = this.productSelector.carBrandId;
        result.isAdvancedSearch = this.productSelector.isAdvancedSearch;
        return result;
    }

    verify():string[]{
        let result :string[] =[];
        let selectedWarehouse = this.warehousePrices.filter(q=>q.selected==true)[0];
        if (typeof selectedWarehouse === 'undefined') 
            result.push('انبار انتخاب نشده است.');
        if (typeof selectedWarehouse !== 'undefined' && this.currentFee < selectedWarehouse.price) 
            result.push('مبلغ کمتر از حد مجاز است.');
        if (this.currentFee <= 0) 
            result.push('قیمت کالا نمی تواند صفر باشد.');
        if (typeof selectedWarehouse !== 'undefined' && selectedWarehouse.balance < 1) 
            result.push('موجودی انبار انتخاب شده صفر است.');
        return result;
    }
    
}
export class file extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set path(v: string) { this._path = v; } public get path(): string { return this._path;} private _path: string;
    
    openInNewTab(){
        window.open(`/media/${this.path}`,'_blank');
    }
    
}

export class OtherSearchResultProduct extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code;} private _code: string;
    public set hasFocus(v: boolean) { this._hasFocus = v; } public get hasFocus(): boolean { return this._hasFocus;} private _hasFocus: boolean;
    
    choose(){
        let message = new RequestHuntProductMessage(this.id);
        this.handleMessage(message);
    }
}

export class ReplaceableProduct extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:HuntViewModel) {
        super(parent);
        this._parent = parent;
    }
    
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code;} private _code: string;
    public set hasFocus(v: boolean) { this._hasFocus = v; } public get hasFocus(): boolean { return this._hasFocus;} private _hasFocus: boolean;
    
    private _parent: HuntViewModel;

    choose(){
        this._parent.productSelector.searchedText = this.code;
        this._parent.productSelector.refresh();
    }
}


export class WarehousePrice extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:HuntViewModel) {
        super(parent);
        this.selected = false;
        this._typedParent = parent;
    }
    
    public set warehouseId(v: string) { this._warehouseId = v; } public get warehouseId(): string { return this._warehouseId;} private _warehouseId: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set districtId(v: string) { this._districtId = v; } public get districtId(): string { return this._districtId;} private _districtId: string;
    public set districtName(v: string) { this._districtName = v; } public get districtName(): string { return this._districtName;} private _districtName: string;
    public set balance(v: number) { this._balance = v; } public get balance(): number { return this._balance;} private _balance: number;
    public set price(v: number) { this._price = v; } public get price(): number { return this._price;} private _price: number;
    public set reserveAmount(v: number) { this._reserveAmount = v; } public get reserveAmount(): number { return this._reserveAmount;} private _reserveAmount: number;
    public set canDelivery(v: boolean) { this._canDelivery = v; } public get canDelivery(): boolean { return this._canDelivery;} private _canDelivery: boolean;
    public set canSelect(v: boolean) { this._canSelect = v; } public get canSelect(): boolean { return this._canSelect;} private _canSelect: boolean;
    public set selected(v: boolean) { this._selected = v; } public get selected(): boolean { return this._selected;} private _selected: boolean;
    private _typedParent :HuntViewModel;

    selectWarehouse () {
        this._typedParent.selectWarehouse(this);    
    }
}

export class SystemPriceHistory extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber;} private _rowNumber: number;
    public set systemPrice(v: number) { this._systemPrice = v; } public get systemPrice(): number { return this._systemPrice;} private _systemPrice: number;
    public set from(v: moment.Moment) { this._from = v; } public get from(): moment.Moment { return this._from;} private _from: moment.Moment;
    public set until(v: moment.Moment) { this._until = v; } public get until(): moment.Moment { return this._until;} private _until: moment.Moment;
    
}

export class InvoicePrices extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber;} private _rowNumber: number;
    public set price(v: number) { this._price = v; } public get price(): number { return this._price;} private _price: number;
    public set invoiceNumber(v: number) { this._invoiceNumber = v; } public get invoiceNumber(): number { return this._invoiceNumber;} private _invoiceNumber: number;
    public set warehouseName(v: string) { this._warehouseName = v; } public get warehouseName(): string { return this._warehouseName;} private _warehouseName: string;
    public set createdDate(v: moment.Moment) { this._createdDate = v; } public get createdDate(): moment.Moment { return this._createdDate;} private _createdDate: moment.Moment;
    public set customerName(v: string) { this._customerName = v; } public get customerName(): string { return this._customerName;} private _customerName: string;
    public set districtName(v: string) { this._districtName = v; } public get districtName(): string { return this._districtName;} private _districtName: string;
    
}

export class InWayAmountPerWarehouse extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    public set warehouseId(v: string) { this._warehouseId = v; } public get warehouseId(): string { return this._warehouseId;} private _warehouseId: string;
    public set warehouseName(v: string) { this._warehouseName = v; } public get warehouseName(): string { return this._warehouseName;} private _warehouseName: string;
    public set inWayAmount(v: number) { this._inWayAmount = v; } public get inWayAmount(): number { return this._inWayAmount;} private _inWayAmount: number;
    
}

export class RequestHuntProductMessage extends ViewModelMessage{
    constructor(measuredProductId:string) {
        super();
        this.measuredProductId = measuredProductId;
    }
    public measuredProductId:string;

}

export class RequestInvoiceCreationSessionIdMessage extends ViewModelMessage{

}